// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-issue-credit-voucheofficer-indetail-report',
//   standalone: true,
//   imports: [],
//   templateUrl: './issue-credit-voucheofficer-indetail-report.component.html',
//   styleUrl: './issue-credit-voucheofficer-indetail-report.component.scss'
// })
// export class IssueCreditVoucheofficerIndetailReportComponent {

// }


import {
  Component,
  OnInit,
  Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-issue-credit-voucheofficer-indetail-report',
  templateUrl: './issue-credit-voucheofficer-indetail-report.component.html',
  styleUrls: ['./issue-credit-voucheofficer-indetail-report.component.scss'],
})
export class IssueCreditVoucheofficerIndetailReportComponent implements OnInit {

  startDate: any;
  endDate: any;
  repName: any;
  issueName: any;
  issueDates: any;
  offRepName: any;
  reportType:any;

  PaymentadvtOffInDFormBenas: any[] = [];
  PaymentadvtOffInDTotal2: number = 0;
  PaymentadvtOffInDTotal3: number = 0;

  constructor(
    private dialogRef: MatDialogRef<IssueCreditVoucheofficerIndetailReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private toaster: ToastrService
  ) {
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.repName = data.repName;
    this.issueName = data.issuename;
    this.issueDates = data.issueDates;
    this.offRepName = data.offRepName;
    this.reportType=data.reportType;

    console.log('Start Date:', this.startDate);
    console.log('End Date:', this.endDate);
    console.log('Rep Name:', this.repName);
    console.log('Issue Name:', this.issueName);
    console.log('Issue Date:', this.issueDates);
    console.log('Off Rep Name:', this.offRepName);
    console.log('reportType:',this.reportType);
  }


  ngOnInit(): void {
    const req = {
 
      rep_name: this.repName,
      startDate: this.startDate,
      endDate: this.endDate,
      off_rep_name: this.offRepName,
      issue_name: this.issueName,
      issue_Date: this.issueDates
    
    };

    this.service.getissuePaymentRegiOffInDetails(req).subscribe((data: any) => {
      console.log("new",data)
        this.PaymentadvtOffInDFormBenas = data as any;
        console.log(this.PaymentadvtOffInDFormBenas, "newlist 3 loop" )
        // Reset totals
        // this.PaymentadvtOffInDTotal = 0;
        this.PaymentadvtOffInDTotal2 = 0;
        this.PaymentadvtOffInDTotal3 = 0;
  
  
  
        // Calculate totals
        for (let repData of this.PaymentadvtOffInDFormBenas) {
          this.PaymentadvtOffInDTotal2 += parseInt(repData.total) || 0;
          this.PaymentadvtOffInDTotal3 += parseInt(repData.net_total) || 0;
  
            for (let data1 of repData.rep_data) {
                // this.PaymentadvtOffInDTotal += parseInt(data1.rcv_amt) || 0;
                // // this.PaymentadvtOffInDTotal2 += parseInt(repdata.total) || 0;
                // this.PaymentadvtOffInDTotal3 += parseInt(data1.rcv_amt) || 0;
            }
        }
        console.log("offcr total",this.PaymentadvtOffInDTotal2)
    });
      (error) => {
        console.error('Error fetching briefly data:', error);
        this.toaster.error('Failed to load brief report', 'Error');
      }
    
  }
  PaymentadvtOffInDTotal(arg0: string, PaymentadvtOffInDTotal2: any) {
    throw new Error('Method not implemented.');
  }
 print() {
    const originalTitle = document.title;
    document.title = '';

    const style = document.createElement('style');
    style.innerHTML = `
      @media print {
        @page {
          size: A4;
          margin: 5mm;
        }
        .print-header {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .print-footer {
          position: fixed;
          bottom: 10px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 12px;
          color: gray;
        }
        .print-footer::after {
          content: "Page " counter(page) " of " counter(pages);
        }
        .no-print {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);

    setTimeout(() => {
      const printTrigger = document.getElementById('print-button');
      if (printTrigger) (printTrigger as HTMLElement).click();
      document.title = originalTitle;
    }, 500);
  }
  exportExcel(fileName: string) {
    // Get the table element
    const element = document.getElementById('print-section');
    if (!element) {
      this.toaster.error('Table not found!');
      return;
    }
  
    // Use XLSX to convert the table to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
    // Create a new workbook and append the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Write workbook and save as Excel file
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
}

